 import { Button } from 'primereact/button';
import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from "primereact/dialog";
import ComplaintDatatable from '../Complaint/ComplaintDatatable';
import { Toast, ToastMessage } from "primereact/toast";
import ComplaintService from '../../services/complaint/ComplaintService';
import { CompCategory, complaintmodel, CompStatus, CompType } from '../../models/complaints/complaint-model';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown, DropdownChangeEvent, DropdownFilterEvent } from 'primereact/dropdown';
import { userOption } from '../../models/orders/order-list-model';
import orderServices from '../../services/orders/orderservice';
import { Calendar } from 'primereact/calendar';
 
interface SearchPanelProps {
  onSearch: (filters: any) => void;
  setLoading: (loading: boolean) => void;
  setComplaintTypes: (types: string[]) => void;
  setNewData: any;
  initialDates?: { 
    startDate: string;
    endDate: string;
  }; 
}
 
const ComplaintSearch: React.FC<SearchPanelProps> = ({
  onSearch,
  setLoading,
  setNewData,
  initialDates
}) => {
  const { t } = useTranslation();
  const [showAddComplaintModal, setShowAddComplaintModal] = useState(false);
  const [selectedComplaint, setSelectedComplaint] = useState<string>("");
  const toast = useRef<Toast>(null);
  const [complainttypes, setcomplaintypes] = useState<CompType[]>([]);
  const [searchComplainttype, setsearchComplainttype] = useState<string[]>([]);
  const [ComplaintCategory, setComplaintcategory] = useState<CompCategory[]>([]);
  const [searchComplaintcategory, setsearchComplaintcategory] = useState<string[]>([]);
  const [searchComplaintstatus, setsearchComplaintstatus] = useState<string[]>([]);
  const [complaintStatus, setcomplaintStatus] = useState<CompStatus[]>([]);
  const blankUserDetail: userOption[] = [{ userID: 0, name: 'Not found', primaryContactNbr: '' }];
  const [orderUser, setOrderUser] = useState<any[]>([]);
  const [orderUsers, setOrderUsers] = useState<userOption[]>(blankUserDetail);
  const [dropdownValue, setDropdownValue] = useState<string | null>(null);
  const [selectedUser, setSelectedUserState] = useState<any>(null);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const [startDate, setStartDate] = useState<any>(yesterday);
  const [endDate, setEndDate] = useState<any>(today);
 
  const FetchComplaintype = async () => {
  const res = await ComplaintService.getComplaintType();
  setcomplaintypes(Array.isArray(res) ? res : []);
};

const FetchComplaintcategory = async () => {
  const res = await ComplaintService.getComplaintCategory();
  setComplaintcategory(Array.isArray(res) ? res : []);
};

const FetchComplaintStatus = async () => {
  const res = await ComplaintService.getComplaintStatus();
  setcomplaintStatus(Array.isArray(res) ? res : []);
};

useEffect(() => {
  console.log("Complaint types:", complainttypes);
  console.log("Complaint category:", ComplaintCategory);
  console.log("Complaint status:", complaintStatus);
}, [complainttypes, ComplaintCategory, complaintStatus]);
 
  const handleSearch = () => {   
    const filters = {
      complaintTypeId: searchComplainttype,
      complaintCategoryId: searchComplaintcategory,
      statusId: searchComplaintstatus,
      // startDate: new Date(startDate).toISOString(),
      startDate: startDate != null ? startDate.getFullYear() + '-' +
      String(startDate.getMonth() + 1).padStart(2, '0') + '-' +
      String(startDate.getDate()).padStart(2, '0') : null,
      //endDate:new Date(endDate).toISOString(),
      endDate: endDate != null ? endDate.getFullYear() + '-' +
      String(endDate.getMonth() + 1).padStart(2, '0') + '-' +
      String(endDate.getDate()).padStart(2, '0') : null,
      customerID: dropdownValue != "" ? dropdownValue : null
    };
   
    onSearch(filters);
  };

  const resetSearchFields = () => {
    setSelectedComplaint("");
    setDropdownValue("");
    setsearchComplainttype([]);
    setsearchComplaintstatus([]);
    setsearchComplaintcategory([]);
    setStartDate(null);
    setEndDate(null);
 
    const defaultFilters = {
      complaintTypeId: [],
      complaintCategoryId: [],
      statusId: [],
      startDate: null,
      endDate: null,
      customerID: null
    };
 
    onSearch(defaultFilters);
  };
 
 
  const handleOnSuccess = () => {
    setShowAddComplaintModal(false);
    showMessage("Add Complaint", "Complaint added successfully", "success");
  };
 
  const showMessage = (label: string, message: string, severity: ToastMessage['severity']) => {
    toast.current?.show({ severity: severity, summary: label, detail: message, life: 3000 });
  };
 
  async function handelnewdata(params: any) {
    setNewData(params);
  }
 
  useEffect(() => {
    FetchComplaintype();
    FetchComplaintcategory();
    FetchComplaintStatus();
 
    if (orderUsers.length > 0) {
      setOrderUser(orderUsers.map((user) => ({
        userID: user.userID,
        detail: user.userID !== 0 ? `${user.name}, ${user.primaryContactNbr}` : "",
      })));
    }
  }, [orderUsers]);
 
  const handleDropdownChange = (e: DropdownChangeEvent) => {
    const selectedUserId = e.value;
    const selectedUser = orderUser.find(user => user.userID === selectedUserId);
 
    if (selectedUser) {
      const [name, primaryContactNbr] = selectedUser.detail.split(",").map((item: string) => item.trim());
      setSelectedUserState({ name, primaryContactNbr });
      setDropdownValue(selectedUserId);
    }
  };
 
  const handleDropdownFilter = (e: DropdownFilterEvent) => {
    if (e.filter.length > 0) {
      orderServices.getOrderUsers(e.filter).then((response: userOption[]) => {
        if (response.length > 0) {
          setOrderUsers(response);
        }
      });
    }
  };
 
  const handleComplaintcategorychange = (e: any) => {
    setsearchComplaintcategory(e.value);
  };
 
  const handleComplaintTypeChange = (e: any) => {
    setsearchComplainttype(e.value);
  };
 
  const handleComplaintstatusChange = (e: any) => {
    setsearchComplaintstatus(e.value);
  };
 
  return (
    <div className="col-12" style={{ width: "100%", padding: "0px", marginBottom: "0.5rem" }}>
      <Toast ref={toast} />
      <div className="card border-noround p-2" style={{ minHeight: '3.5rem' }}>
        <div className="p-fluid grid p-2">
          <div className="col-12 md:col-4" style={{ paddingBottom: "10px" }}>
            <Dropdown
              id="SearchUser"
              name="SearchUser"
              options={orderUser || []}
              optionLabel="detail"
              optionValue="userID"
              value={dropdownValue}
              onChange={handleDropdownChange}
              onFilter={handleDropdownFilter}
              filter
              placeholder="Search for Customer/Mobile"
              style={{ width: '100%' }}
            />
          </div>
 
          <div className="col-12 md:col-4" style={{ paddingBottom: "10px" }}>
            <MultiSelect
              id="complaintTypeId"
              name="Complainttype"
              options={complainttypes}
              optionLabel="complaintName"
              optionValue="complaintTypeId"
              value={searchComplainttype}
              display="chip"
              onChange={handleComplaintTypeChange}
              placeholder="Choose Complaint Type"
              style={{ width: "100%" }}
            />
          </div>
 
          <div className="col-12 md:col-4" style={{ paddingBottom: "10px" }}>
            <MultiSelect
              id="complaintcategoryId"
              name="complaintName"
              options={ComplaintCategory}
              optionLabel="complaintName"
              optionValue="complaintCategoryId"
              value={searchComplaintcategory}
              display="chip"
              onChange={handleComplaintcategorychange}  
              placeholder="Choose Complaint Category"
              style={{ width: "90%", marginInline: "15px" }}
            />
          </div>
 
          <div className="col-12 md:col-4" style={{ paddingBottom: "10px" }}>
            <MultiSelect
              id="statusId"
              name="name"
              options={complaintStatus}
              optionLabel="name"
              optionValue="statusId"
              value={searchComplaintstatus}
              display="chip"
              onChange={handleComplaintstatusChange}  
              placeholder="Choose Status"
              style={{ width: "100%", marginInline: "20px", marginLeft: "2px" }}
            />
          </div>
 
          <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round"
               style={{ display: 'flex', justifyContent: 'space-between', padding: '5px' }}>
            <Calendar
              value={startDate}  
              onChange={(e) => setStartDate(e.value || yesterday)}
              dateFormat="dd/mm/yy"
              style={{ width: "50%", marginRight:"10px" }}
              placeholder="Start date 🗓️"
              showButtonBar
            />
            <Calendar
              value={endDate}  
              onChange={(e) => setEndDate(e.value || new Date())}
              dateFormat="dd/mm/yy"
              style={{ width: "50%"}}
              placeholder="End date 🗓️"
              showButtonBar
            />
          </div>
 
          <div className="col-12 md:col-4 flex align-items-center gap-3 ">
            <Button
              className="text-black border-round"
              style={{ width: "30%" }}
              onClick={handleSearch}
              severity="success"
            >
              Filter
            </Button>
 
            <Button
              className="text-black border-round"
              style={{ width: "30%" }}
              onClick={resetSearchFields}
              severity="secondary"
              text
              raised
            >
              Reset
            </Button>
 
            {/* <Button
              className="bg-blue-700 border-round text-white"
              style={{ width: "50%"}}
              onClick={() => setShowAddComplaintModal(true)}
              severity="secondary"
              text
              raised
            >
              Add Complaint
            </Button> */}
          </div>
        </div>
 
        {/* <Dialog
          visible={showAddComplaintModal}
          className="quickview w-50"
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          modal
          onHide={() => setShowAddComplaintModal(false)}
        >
          <ComplaintDatatable
            isUpdate={false}
            handleOnSuccess={handleOnSuccess}
            updateComplaintInfo={null}
            AddedData={handelnewdata}
          />
        </Dialog> */}
      </div>
    </div>
  );
};
 
export default ComplaintSearch;
